/**
 * Decodes the `bh_claims.products[0].status` entitlement status embedded in a
 * Supabase access token — used to decide whether activate/confirm still needs
 * to run before completing a session handoff.
 */
export const getEntitlementStatus = (accessToken: string): string | undefined => {
  try {
    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    return payload.bh_claims?.products?.[0]?.status;
  } catch {
    return undefined;
  }
};
